import React, { Component} from 'react';
import { translate } from 'react-i18next';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import swal from 'sweetalert';

var Config = require('../../../../config');

class AddressData extends Component{
	constructor(props) {
	    super(props);
	    this.updateState = this.updateState.bind(this);
	    this.state = {
	    	estado:"",
	      	states:[],
	      	searchText: '',
	      	mpios:[],
	      	dataSource:[],
	      	options:[],
	      	mpioSelected:[],
	      	indice:-1,
	      	isLoading: false,
	      	default_values:{text: 'value_name',value: 'value_name'},
	      	scholarships:[],
	    };
	}

	//Consulta de servicios necesarios para la pantalla
	componentDidMount() {
		this.props.onRef(this);

		fetch(Config.default.apiGateway.URL+'lookups_level2?type=state_mx&option=parents',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      states: response
		    });
		})
	}

	componentDidUpdate(){
		
	}

	componentWillUnmount() {
	    this.props.onRef(null)
	}

	selectFieldHandle = (id, name, event, index, value) => {
		this.props.selectFieldHandle("id","state",event, index, value);
		
	}

	getMpios(key,mpio){
		
		if(mpio!=="" && mpio !== null){
			this.setState({indice:0})
			this.props.autocompleteHandle('mpio',mpio);
			this.props.autocompleteHandle('state',key !== null ? key : "");
			this._handleSearch((mpio.replace(/_/g, " ")).toLowerCase());
		}
	}

	handleUpdateInput = (searchText) => {
	    this.setState({
	      searchText: searchText,
	    });
  	};

  	_handleSearch = (query) => {
  		this.setState({mpioSelected:[], indice: -1});

	    this.setState({isLoading: true});
		fetch(Config.default.apiGateway.URL+'lookups_level2?type='+query+'&option=municipios',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response.length > 0){
				for (var i = 0; i < response.length; i++) {
					response[i].names = response[i].municpio.value_name +', '+response[i].estado.value_name;
					response[i].id = i;
				};
				this.setState({
					isLoading: false,
			      	options: response
			    });

			    if (response.length > 1) {
			    	response.map((res, i)=>{

			    		if(this.props.state.state !== ""){
			    			if(res.estado.key.toUpperCase() === this.props.state.state.toUpperCase() &&
				    			res.municpio.value_name.toUpperCase() === query.toUpperCase()){
				    	
				    			this.updateState([res], i)
				    		}
			    		}else{
			    			if(res.municpio.value_name.toUpperCase() === query.toUpperCase()){
				    			this.updateState([res], i)
				    		}
				    	}	
			    	})
			    		

			    }else {
			    	this.setState({mpioSelected:response})
			    };

			}else{
				this.props.autocompleteHandle('mpio','');
				this.props.autocompleteHandle('state','');
				this.setState({isLoading:false})
			}
				
		})
	}

	updateState = (values,index) =>{
		if(values!== undefined){
			if(values.length>0){
				this.props.autocompleteHandle('mpio',values[0].municpio.key);
				this.props.autocompleteHandle('state',values[0].estado.key);
				this.setState({indice:values[0].id,mpioSelected:values})
			}
		}

	};

	setMpio = (event, values) => {
	}

	clearSearch(){
		this.refs._handleSearch._instance.getInstance().clear();
		this.setState({mpioSelected:[]});
	}

	render() {
		const { t } = this.props;
	    return (
	      	<div className="col-xs-12" style={{padding:"0px"}}>{console.log(this.props.state)}
				<div className="col-xs-12" style={{padding:"0px"}}>
                    {this.props.state.fields_patient.map((field, i)=>
                        field.section_key === 'PATIENT' ?
                            field.print ?
                                field.key === 'PATIENT_STREET' ?
                                    <div className="col-xs-12 col-sm-6" key={i}>
                                        <span className="span-min">{t('content.generics.address.street')}</span>
                                        <input name="street" id="street" value={ this.props.state.street } disabled={this.props.state.disableFields} required={field.required} maxLength="255"
                                                onChange={ this.props.handleChange } type="text" className="form-control input_data_donor" onKeyPress={(e) => this.props.validate(e)}/>
                                    </div>
								: field.key === 'PATIENT_EXT_NUM' ?
									<div className="col-xs-12 col-sm-2" key={i}>
										<span className="span-min">No. Exterior</span>
										<input name="no_ext" id="no_ext" value={ this.props.state.no_ext } disabled={this.props.state.disableFields} maxLength="4" required={field.required}
												onChange={ this.props.handleChange } type="ext" className="form-control input_data_donor" onKeyPress={(e) => this.props.validate(e)}/>
									</div>
								: field.key === 'PATIENT_COLONIA' ?
									<div className="col-xs-12 col-sm-4" key={i}>
										<span className="span-min">Colonia</span>
										<input name="colonia" id="colonia" value={ this.props.state.colonia } disabled={this.props.state.disableFields} maxLength="50" required={field.required}
												onChange={ this.props.handleChange } type="ext" className="form-control input_data_donor" onKeyPress={(e) => this.props.validate(e)}/>
									</div>
                                : null
                            : null
                        : null
                    )}

					
					
				</div>

				<div className="col-xs-12" style={{padding:"0px"}}>
                    {this.props.state.fields_patient.map((field, i)=>
                        field.section_key === 'PATIENT' ?
                            field.print ?
                                field.key === 'PATIENT_POSTAL_CODE' ?
                                    <div className="col-xs-12 col-sm-4" key={i}>
                                        <span className="span-min">{t('content.generics.address.postal_code')}</span>
                                        <input name="postal_code" id="postal_code" value={ this.props.state.postal_code } onKeyPress={(e) => this.props.validate(e)}  
                                            onChange={ this.props.handleChange } type="text" className="form-control input_data_donor" maxLength="5" minLength="5"
                                            disabled={this.props.state.disableFields} required={field.required} />
                                    </div>
                                : field.key === 'PATIENT_MUNICIPIO' ?
                                    <div className=" col-xs-12 col-sm-4" key={i}>
                                        <span className="span-min">{t('content.generics.address.mpio')}</span>
                                        
                                        <AsyncTypeahead
                                        disabled={this.props.state.disableFields ? this.props.state.disableFields : this.props.state.disableOnView}
                                        labelKey={(option) => `${option.names}`}
                                        minLength={3}
                                        name="mpio"
                                        id="mpio" onKeyPress={(e) => this.props.validate(e)}
                                        inputProps={{
                                            name:"MUNICIPIO",
                                            id:"MUNICIPIO",
                                            className:"input_data_donor",
                                            required:field.required
                                        }}
                                        //className="input_data_donor"
                                        onSearch={this._handleSearch}
                                        options={this.state.options}
                                        onChange={this.updateState.bind(this.props.index)}
                                        defaultSelected={this.state.options.slice(this.state.indice, 1)}
                                        selected={this.state.mpioSelected}
                                        ref="_handleSearch"
                                        useCache={false}
                                        isLoading={this.state.isLoading}
                                        delay={600}
                                        paginationText="Mostrar mas resultados..."
                                        />
                                        
                                    </div>
                                : field.key === 'PATIENT_ESTADO' ?
                                    <div className=" col-xs-12 col-sm-4" key={i}>
                                        <div >
                                            <span className="span-min">{t('content.generics.address.state')} </span>
                                            <select className="form-control input_data_donor" disabled={true} name="state" id="state"
                                                value={ this.props.state.state || ""} onKeyPress={(e) => this.props.validate(e)}
                                                onChange={ this.selectFieldHandle.bind(null,"id","state") } required={field.required}>
                                                <option value="" disabled></option>
                                                {
                                                    this.state.states.map((s)=> {
                                                        return <option key={s.id} 
                                                            value={this.props.state.state === s.key ?
                                                                s.key
                                                            : s.key.toUpperCase()}>
                                                                {s.value_name}
                                                        </option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                : null
                            : null
                        : null
                    )}
					
					
			        
				</div>
	      	</div>
	    );
	}
}

export default translate('translations')(AddressData);